/* unplugin-vue-components disabled */import script from "./IntegralTravelPriceOperate.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralTravelPriceOperate.vue?vue&type=script&setup=true&lang=js"

import "./IntegralTravelPriceOperate.vue?vue&type=style&index=0&id=40ed735a&lang=scss"

const __exports__ = script;

export default __exports__